
import React, { useState } from 'react';
import CoreStep from './CoreStep';
import InfoBlock from '../Partials/InfoBlock';
import { useDispatch, useSelector } from 'react-redux';
import { updateAttribute } from '../../../actions/DirectQuoteActions';
import LocationInput from '@/elements/inputs/LocationInput';
import Alert from '@/components/Alert/Alert';
import Input from '@/elements/Input';

export default function Location({ progressBlock, title, progressTitle, stepsToSkipNext = false, stepsToSkipPrev = false, isLastStep = false, stepName = null }) {
    const dispatch = useDispatch();
    const [editPostcode, setEditPostcode] = useState(true);
    const [isPostcodeValid, setIsPostcodeValid] = useState(true);
    const [isInternational, setIsInternational] = useState(false);
    const [error, setError] = useState(false);
    const directQuote = useSelector((state) => state.directQuote);
    // const [editPostcode, setEditPostcode] = useState(() => directQuote.quote.postcode ? false : true);

    const handleEditPostcode = () => {
        setEditPostcode(true);
    };

    const isValid = () =>
        directQuote.quote.postcode && directQuote.quote.addressType && isPostcodeValid && !isInternational;

    const renderStep = () => {
        return (
            <>
                <div className={`form-group ${editPostcode ? '' : '-edit'}`}>
                    <div className='form-item'>
                        <Input
                            inputType="custom"
                            label="Event address"
                            className="[&_.form-group]:m-0"
                            error={error !== '' && !isInternational ? error : undefined}
                        >
                            {editPostcode ? (
                                <LocationInput
                                    value={directQuote.quote.postcode && directQuote.quote.postcode !== 'false' ? directQuote.quote.postcode : ''}
                                    country={directQuote.quote.country}
                                    onChange={(postcode, country) => {
                                        dispatch(updateAttribute('postcode', postcode));
                                        dispatch(updateAttribute('country', country));
                                    }}
                                    onValidationChange={({ isValidLocation, isInternational, error }) => {
                                        setIsPostcodeValid(isValidLocation);
                                        setIsInternational(isInternational);
                                        setError(error);
                                    }}
                                />
                            ) : (
                                <span className='details'>{directQuote.quote.postcode}</span>
                            )}
                        </Input>
                    </div>

                    {!editPostcode && <div className='form-edit' onClick={handleEditPostcode}>Edit</div>}
                </div>

                <div className='form-group'>
                    <label htmlFor='addressType'>Type of address</label>
                    <input type='radio' id='home' name='addressType' required value='Home' checked={directQuote.quote.addressType === 'Home'} onChange={(event) => dispatch(updateAttribute('addressType', event.target.value))} />
                    <label htmlFor='home' className={`radio ${(directQuote.quote.addressType === 'Home') ? '-selected' : ''}`}>Home</label>

                    <input type='radio' id='friendhome' name='addressType' required value='Friend Home' checked={directQuote.quote.addressType === 'Friend Home'} onChange={(event) => dispatch(updateAttribute('addressType', event.target.value))} />
                    <label htmlFor='friendhome' className={`radio ${(directQuote.quote.addressType === 'Friend Home') ? '-selected' : ''}`}>Friend’s/Relative’s home</label>

                    <input type='radio' id='rented' name='addressType' required value='Rented Venue' checked={directQuote.quote.addressType === 'Rented Venue'} onChange={(event) => dispatch(updateAttribute('addressType', event.target.value))} />
                    <label htmlFor='rented' className={`radio ${(directQuote.quote.addressType === 'Rented Venue') ? '-selected' : ''}`}>Rented venue</label>
                </div>

                {(directQuote.quote.postcode != '' && isInternational) &&
                    <Alert
                        title={`We're currently operating mainly in the UK and the US`}
                        text={`If you have an international query, please email info@yhangry.com`}
                        type='secondary'
                        dismissible={false}
                    />
                }
            </>
        );
    };

    return (
        <CoreStep
            title={title}
            isValid={isValid}
            stepName={stepName}
            renderStep={renderStep}
            isLastStep={isLastStep}
            progressBlock={progressBlock}
            progressTitle={progressTitle}
            stepsToSkipNext={stepsToSkipNext}
            stepsToSkipPrev={stepsToSkipPrev}
        />
    );
}
